import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, DialogProps, IconButton, useMediaQuery } from '@material-ui/core';
import { DefaultTheme } from 'themes/interfaces/default-theme.interfaces';
import { defaultTheme } from 'themes/default-theme';
import { Close } from '@material-ui/icons';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import clsx from 'clsx';

const makeClasses = makeStyles<DefaultTheme>(theme => ({
  root: {
    position: 'relative',
  },
  container: {
    width: '90%',
    maxWidth: '100%'
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    fill: theme.palette.common.black
  }
}));

export interface ResponsiveModalProps extends DialogProps {
  className?: string;
  closeButton?: boolean;
  fullScreenBreakpoint?: Breakpoint;
}

export const ResponsiveModal: React.FC<ResponsiveModalProps> = props => {
  const { className, children, closeButton = true, fullScreenBreakpoint, ...rest } = props;
  const classes = makeClasses();
  const fullScreen = useMediaQuery(defaultTheme.breakpoints.down(fullScreenBreakpoint || 'xs'));

  return (
    <Dialog closeAfterTransition fullScreen={fullScreen} {...rest} className={clsx(classes.root, className)} disableBackdropClick>
      {children}
      {closeButton && (
        <IconButton
          className={classes.closeButton}
          onClick={event => {
            if (props.onClose) {
              props.onClose(event, 'backdropClick');
            }
          }}
        >
          <Close />
        </IconButton>
      )}
    </Dialog>
  );
};
